var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIphoneAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.7 165.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 10px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: gray;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-width: 13px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5,
    y: 5,
    width: 76.7,
    height: 155.63,
    rx: 13.12,
    ry: 13.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.04,
    y1: 29.54,
    x2: 56.65,
    y2: 29.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneAsset);
export default __webpack_public_path__ + "static/media/iphoneAsset.a87e11df032dd21ed1ae4e76fe1576ba.svg";
export { ForwardRef as ReactComponent };